
















































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    closeMenu() {
      this.isActive = false;
    },
  },
});
